"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NavBarMain;
var _react = _interopRequireDefault(require("react"));
var _link = _interopRequireDefault(require("./link"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const DetectMobile = require('detect-mobile-browser')(false);
if (typeof window !== 'function' && typeof window !== 'object') {
  DetectMobile.setUserAgent('');
}
const isMobile = DetectMobile.isAny();
const navBarClass = isMobile ? 'hidden-print' : 'hidden-print pos-f-t';
const NavBarStyled = _styledComponents.default.nav`
  border-radius: 0;
`;
var _ref = /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
  src: "/public/cse-logo.jpg",
  height: "40px",
  alt: "Canoe Slalom Entries Home Page"
}), ' Home');
function NavBarMain(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: navBarClass
  }, /*#__PURE__*/_react.default.createElement(NavBarStyled, {
    className: "navbar navbar-dark bg-primary"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "nav navbar-nav"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-item nav-link",
    style: {
      padding: 0
    },
    activeClassName: "active",
    exact: true,
    to: "/",
    type: "img"
  }, _ref), props.children)));
}